module.exports = __webpack_public_path__ + "static/media/Columbia Indonesian Society (ISUCI).2eb443fd.jpg";